import { useLocation, useNavigate } from 'react-router-dom'

import './mosquito-observation-tabs.styl'

function MosquitoObservationTabs() {
  const navigate = useNavigate()
  const location = useLocation()

  const isTrapsRoute = location.pathname.includes('/mosquito-observations/detections')

  const switchMosquitoRoute = (mode) => {
    const nextPath = location.pathname.replace(/\/mosquito-observations\/(sightings|detections)/, `/mosquito-observations/${mode}`)
    navigate(`${nextPath}${location.search}${location.hash}`)
  }

  return (
    <div className="mosquito-observations-tabs">
      <button
        className={
          `mosquito-observations-tabs__tab`
          + `${isTrapsRoute ? ' mosquito-observations-tabs__tab--inactive' : ''}`
        }
        onClick={() => switchMosquitoRoute('sightings')}
      >
        Sightings
      </button>
      <button
        className={
          `mosquito-observations-tabs__tab`
          + ` ${!isTrapsRoute ? ' mosquito-observations-tabs__tab--inactive' : ''}`
        }
        onClick={() => switchMosquitoRoute('detections')}
      >
        Traps
      </button>
    </div>
  )
}

export default MosquitoObservationTabs
